function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".logo-yellow_svg__cls-1{fill:#ddd33d}"));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  className: "logo-yellow_svg__cls-1",
  d: "M34.84 170.76a1.5 1.5 0 0 0-2.88.47l-1.42 17.27c-3.22 37.79-7.22 42.61-30.54 42.61V250h87.22v-18.89c-16.83 0-29.45-8.54-36.28-23.88-3.24-7.23-11.33-25.4-16.1-36.47zM112.14 0H14.87v18.89c18.09 0 41.05 14 51.86 39.4C71.15 68.66 151.53 250 151.53 250h13.66l28.66-65zM312.78 0h-65.19l20.29 250h66L312.78 0z"
});

var SvgLogoYellow = function SvgLogoYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-yellow_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 333.88 250"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMzMuODggMjUwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2RkZDMzZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmxvZ288L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTM0Ljg0LDE3MC43NmExLjUsMS41LDAsMCwwLTIuODguNDdMMzAuNTQsMTg4LjVDMjcuMzIsMjI2LjI5LDIzLjMyLDIzMS4xMSwwLDIzMS4xMVYyNTBIODcuMjJWMjMxLjExYy0xNi44MywwLTI5LjQ1LTguNTQtMzYuMjgtMjMuODhDNDcuNywyMDAsMzkuNjEsMTgxLjgzLDM0Ljg0LDE3MC43NloiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMTIuMTQsMEgxNC44N1YxOC44OWMxOC4wOSwwLDQxLjA1LDE0LDUxLjg2LDM5LjRDNzEuMTUsNjguNjYsMTUxLjUzLDI1MCwxNTEuNTMsMjUwaDEzLjY2bDI4LjY2LTY1WiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIzMTIuNzggMCAyNDcuNTkgMCAyNjcuODggMjUwIDMzMy44OCAyNTAgMzEyLjc4IDAiLz48L3N2Zz4=";
export { SvgLogoYellow as ReactComponent };